<script setup>
import { computed } from 'vue'

/**
 * The workspace's identity mark: its accent color with the first letter of its
 * name. Used everywhere a workspace is named, so the same color+letter pairing
 * is what a user learns to recognise across the sidebar, modals and billing.
 */
const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: '#3b82f6',
  },
  // Tailwind size utility, e.g. `size-7`.
  size: {
    type: String,
    default: 'size-7',
  },
  textClass: {
    type: String,
    default: 'text-tiny',
  },
  rounded: {
    type: String,
    default: 'rounded-md',
  },
})

const initial = computed(() => {
  const trimmed = (props.name || '').trim()
  return trimmed ? trimmed.charAt(0).toUpperCase() : '?'
})
</script>

<template>
  <span
    class="shrink-0 grid place-items-center font-semibold uppercase text-white select-none"
    :class="[size, textClass, rounded]"
    :style="{ backgroundColor: color }"
    aria-hidden="true"
  >
    {{ initial }}
  </span>
</template>
